import { noop } from 'lodash';

import { defaultMemoizedContextValue, type MemoizedContextType } from '@air/react-memoized-context';

import { type FreeformAnnotation } from '~/components/Annotations/shared/types';

export type AnnotationContextValue = {
  activeAnnotation?: FreeformAnnotation;
};

export type AnnotationContextType = {
  setActiveAnnotation: (value?: FreeformAnnotation) => void;
} & MemoizedContextType<AnnotationContextValue>;

export const defaultValue: AnnotationContextType = {
  ...defaultMemoizedContextValue,
  getValue: () => ({}),
  setActiveAnnotation: noop,
};

export enum AnnotationProviderActions {
  setActiveAnnotation = 'setActiveAnnotation',
}
